export const onFormatDate = (date?: Date | null): string => {
	return !date
		? ''
		: date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
};
